var map = {
	"./views/FourSoS/4SoS.vue": [
		66909,
		6909
	],
	"./views/FourSoS/4SoSWhiteRollCall.vue": [
		60334,
		334
	],
	"./views/TumbleRadar/Radar.vue": [
		65973,
		2704,
		5973
	],
	"./views/TumbleRadar/newRadar2024.vue": [
		40172,
		2704,
		172
	],
	"./views/TumbleRadar/radar_chitongda_Jiangxichangtian.vue": [
		49184,
		2704,
		9184
	],
	"./views/activity/activity_calendar.vue": [
		42894,
		2894
	],
	"./views/activity/activity_in_statistics.vue": [
		88134,
		8134
	],
	"./views/activity/activity_manager.vue": [
		8042,
		8042
	],
	"./views/activity/activity_satisfaction.vue": [
		23426,
		3426
	],
	"./views/activity/activity_statistics.vue": [
		22630,
		2630
	],
	"./views/activity/activity_summary.vue": [
		11698,
		1698
	],
	"./views/activity/activity_type.vue": [
		17129,
		7129
	],
	"./views/activity/scoring_approval.vue": [
		19866,
		9866
	],
	"./views/activity/sign_up.vue": [
		54560,
		4560
	],
	"./views/activity/volunteer_manager.vue": [
		5859,
		5859
	],
	"./views/aged/aged_ability.vue": [
		26662,
		6662
	],
	"./views/aged/aged_category.vue": [
		67059,
		7059
	],
	"./views/aged/aged_death.vue": [
		31707,
		1707
	],
	"./views/aged/aged_delivery.vue": [
		31986,
		1986
	],
	"./views/aged/aged_detail.vue": [
		22000
	],
	"./views/aged/aged_disability.vue": [
		15155,
		5155
	],
	"./views/aged/aged_record.vue": [
		61396,
		1396
	],
	"./views/aged/aged_record_abnormal_dw.vue": [
		78095,
		8095
	],
	"./views/aged/aged_record_abnormal_jiashu.vue": [
		19218,
		6837
	],
	"./views/aged/aged_record_abnormal_quhua.vue": [
		92019,
		4400
	],
	"./views/aged/aged_record_abnormal_sfz.vue": [
		5205,
		5205
	],
	"./views/aged/aged_residence.vue": [
		58045,
		8045
	],
	"./views/aged/health_record.vue": [
		49872,
		9872
	],
	"./views/aged/health_registration.vue": [
		67870,
		7870
	],
	"./views/ai/ai_evaluation_room_camera.vue": [
		47000,
		7000
	],
	"./views/ai/ai_evaluation_table.vue": [
		2203,
		9057,
		1528
	],
	"./views/ai/ai_robot.vue": [
		34004,
		4004
	],
	"./views/ai/ai_znpgs.vue": [
		88656,
		5800,
		8656
	],
	"./views/ai/cameraPlay.vue": [
		64781,
		4781
	],
	"./views/ai/deepseek.vue": [
		3945,
		3945
	],
	"./views/ai/health-assessment.vue": [
		99417,
		9417
	],
	"./views/aotong/aotong.vue": [
		9430,
		4873,
		3058,
		2690
	],
	"./views/aotong/full_screen.vue": [
		40888,
		3058,
		888
	],
	"./views/aotong/report.vue": [
		9612,
		3058,
		9612
	],
	"./views/app/aged.vue": [
		84919,
		4919
	],
	"./views/app/assessment_pg.vue": [
		34808,
		4808
	],
	"./views/app/index.vue": [
		96072,
		6072
	],
	"./views/app/indexXcx.vue": [
		71995,
		1995
	],
	"./views/app/login.vue": [
		23024,
		3024
	],
	"./views/bank/BankStatement.vue": [
		81745,
		1745
	],
	"./views/basics/employee_manager.vue": [
		38319,
		8319
	],
	"./views/basics/provider_employee.vue": [
		44704,
		4704
	],
	"./views/basics/provider_manager.vue": [
		74286,
		4286
	],
	"./views/bdsxt/token.vue": [
		3262,
		9057,
		6921
	],
	"./views/bioland/Sphygmomanometer.vue": [
		59097,
		9097
	],
	"./views/bioland/glucometer.vue": [
		93759,
		3759
	],
	"./views/boshi/boshi.vue": [
		73730,
		3730
	],
	"./views/boshi/boshi_alarm.vue": [
		91073,
		1073
	],
	"./views/boshi/boshi_position_location.vue": [
		35737,
		5737
	],
	"./views/boshi/boshi_shoubiao.vue": [
		48059,
		8059
	],
	"./views/boshi/boshi_shouhuan.vue": [
		21061,
		1061
	],
	"./views/call/call_history.vue": [
		87926,
		7926
	],
	"./views/call/test.vue": [
		64647,
		4647
	],
	"./views/call/testHome.vue": [
		26233,
		6233
	],
	"./views/center/service/appendix.vue": [
		91057,
		1057
	],
	"./views/center/service/conduct.vue": [
		68732,
		8732
	],
	"./views/center/service/construction_already_examine.vue": [
		87631,
		7631
	],
	"./views/center/service/construction_civil.vue": [
		1272,
		1272
	],
	"./views/center/service/construction_examine.vue": [
		43921,
		3921
	],
	"./views/center/service/construction_failed.vue": [
		1023,
		1023
	],
	"./views/center/service/daily_patrol.vue": [
		87515,
		7515
	],
	"./views/center/service/service_already_examine.vue": [
		56413,
		6413
	],
	"./views/center/service/service_civil.vue": [
		62380,
		2380
	],
	"./views/center/service/service_construction.vue": [
		42501,
		2501
	],
	"./views/center/service/service_examine.vue": [
		76665,
		6665
	],
	"./views/center/service/service_failed.vue": [
		44622,
		4622
	],
	"./views/center/service/service_wo.vue": [
		52419,
		2419
	],
	"./views/center/service/slh_aged.vue": [
		94262,
		4262
	],
	"./views/center/service/slh_aged_new.vue": [
		15866,
		5866
	],
	"./views/center/service/slh_qindan.vue": [
		12019,
		2019
	],
	"./views/center/service/slh_qindan_xining.vue": [
		80337,
		337
	],
	"./views/center/wo/temp_workorder.vue": [
		93983,
		3983
	],
	"./views/center/wo/workorder_abnormal.vue": [
		75083,
		5083
	],
	"./views/center/wo/workorder_content.vue": [
		25815,
		5815
	],
	"./views/center/wo/workorder_deleted.vue": [
		53711,
		3711
	],
	"./views/center/wo/workorder_manager.vue": [
		84915,
		4915
	],
	"./views/center/wo/workorder_manager_vc.vue": [
		20908,
		908
	],
	"./views/center/wo/workorder_nomv.vue": [
		41638,
		1638
	],
	"./views/center/wo/workorder_nopic.vue": [
		31642,
		1642
	],
	"./views/center/wo/workorder_overtime.vue": [
		71896,
		1896
	],
	"./views/chiTongDaSleepRadar/ChiTongDaSleepRadar.vue": [
		93521,
		2704,
		3521
	],
	"./views/crm/crm.vue": [
		53858,
		3858
	],
	"./views/crm/crm_push_content.vue": [
		24328,
		4328
	],
	"./views/device/device_matong.vue": [
		89011,
		9011
	],
	"./views/device/hdcs_simulator.vue": [
		21997,
		1997
	],
	"./views/device/hdcs_test.vue": [
		88785,
		8785
	],
	"./views/erweima/product.vue": [
		33611,
		3611
	],
	"./views/exam/ExamAnswersUser.vue": [
		23973,
		3973
	],
	"./views/exam/ExamCategoriesSubjectStandard.vue": [
		50345,
		2726
	],
	"./views/exam/ExamPaper.vue": [
		47406,
		7406,
		5769
	],
	"./views/exam/ExamPaper_6.vue": [
		33518,
		3518
	],
	"./views/exam/ExamPaper_8.vue": [
		2114,
		2114
	],
	"./views/exam/ExamPapersUser.vue": [
		30526,
		526
	],
	"./views/exam/ExamQuestPaRelationStandard.vue": [
		53572,
		3572
	],
	"./views/exam/ExamQuestionsStandard.vue": [
		81938,
		1938
	],
	"./views/exam/ExamQuestionsUser.vue": [
		84389,
		4389
	],
	"./views/exam/GameDemo.vue": [
		25672,
		1215,
		9135,
		4761,
		1529,
		3573,
		5672
	],
	"./views/exam/GameIndex.vue": [
		66269,
		1215,
		9135,
		4761,
		1529,
		3573,
		6269
	],
	"./views/exam/examAnswersStandard.vue": [
		42573,
		2573
	],
	"./views/exam/examIndex.vue": [
		96637,
		7406,
		7813
	],
	"./views/exam/examhome.vue": [
		99027,
		1215,
		9135,
		4761,
		1529,
		7406,
		3573,
		6683
	],
	"./views/exam/jiqirenui/CognitiveAssessment.vue": [
		62682,
		1215,
		9135,
		4761,
		1529,
		2682
	],
	"./views/exam/jiqirenui/CognitiveTraining.vue": [
		67856,
		1215,
		9135,
		4761,
		1529,
		7856
	],
	"./views/exam/jiqirenui/ScaleAssessment.vue": [
		66705,
		7406,
		25
	],
	"./views/faceEquipment/FaceEquipment.vue": [
		96511,
		6511
	],
	"./views/faceEquipment/FaceEquipmentAged.vue": [
		66211,
		6211
	],
	"./views/geo/aged.vue": [
		76426,
		6426
	],
	"./views/geo/aiqiangua.vue": [
		58649,
		8649
	],
	"./views/geo/aiqiangua_chuangdai.vue": [
		94267,
		4267
	],
	"./views/geo/newAged.vue": [
		8142,
		8142
	],
	"./views/geo/yunxin_idCard.vue": [
		21813,
		1813
	],
	"./views/geo/yunxing_SoS.vue": [
		77300,
		7300
	],
	"./views/gongdan/gaizhao.vue": [
		89200,
		9200
	],
	"./views/gongdan/gongdan.vue": [
		92421,
		2421
	],
	"./views/h5/my.vue": [
		55433,
		5433
	],
	"./views/h5/service.vue": [
		89094,
		9094
	],
	"./views/health/dispepHealthAbility.vue": [
		49463,
		9463
	],
	"./views/health/healthAbility.vue": [
		86132,
		6132
	],
	"./views/health/healthPage-zhaoshang.vue": [
		59587,
		9587
	],
	"./views/health/healthPage.vue": [
		70108,
		108
	],
	"./views/health/healthTransform.vue": [
		20561,
		561
	],
	"./views/healthentiretyequipment/healthentiretyequipment.vue": [
		98099,
		8099
	],
	"./views/healthentiretyequipment/showHealthEquipment.vue": [
		67080,
		7080
	],
	"./views/hmp/healthDrugUse.vue": [
		35605,
		5605
	],
	"./views/hmp/healthRecord.vue": [
		11391,
		1391
	],
	"./views/hmp/healthRisk.vue": [
		59983,
		9983
	],
	"./views/hmp/tittleResult.vue": [
		6797,
		6797
	],
	"./views/home/home-new.vue": [
		81002
	],
	"./views/home/home-taihe.vue": [
		35962,
		5962
	],
	"./views/im/Age.vue": [
		42936,
		2936
	],
	"./views/im/Manage.vue": [
		55652,
		5652
	],
	"./views/im/im.vue": [
		51402,
		1402
	],
	"./views/im/index.vue": [
		60525,
		1709,
		525
	],
	"./views/index.vue": [
		89555
	],
	"./views/institution/agedInstitution.vue": [
		62342,
		2342
	],
	"./views/institution/agedInstitutionAll.vue": [
		40049,
		7954,
		4830
	],
	"./views/institution/amountName.vue": [
		17088,
		7088
	],
	"./views/institution/bed.vue": [
		92561,
		2561
	],
	"./views/institution/bedAll.vue": [
		10687,
		687
	],
	"./views/institution/byj.vue": [
		64148,
		7954,
		9665
	],
	"./views/institution/catering.vue": [
		73175,
		3175
	],
	"./views/institution/electric.vue": [
		98228,
		8228
	],
	"./views/institution/nurse.vue": [
		48976,
		8976
	],
	"./views/institution/qt.vue": [
		40323,
		7954,
		1088
	],
	"./views/institution/qtall.vue": [
		20683,
		7954,
		6152
	],
	"./views/institution/rates.vue": [
		67796,
		7796
	],
	"./views/institution/wallet.vue": [
		22190,
		7954,
		1931
	],
	"./views/institution/wallettuizhu.vue": [
		17114,
		7954,
		3951
	],
	"./views/institution/yjf.vue": [
		10609,
		7954,
		1918
	],
	"./views/institution/yjfall.vue": [
		69416,
		7954,
		8301
	],
	"./views/jingDa/jing_da.vue": [
		11197,
		1197
	],
	"./views/jituan/aged_record.vue": [
		56992,
		6992
	],
	"./views/jituan/healthPage.vue": [
		92829,
		2829
	],
	"./views/jituan/nbiot.vue": [
		46177,
		6177
	],
	"./views/jituan/slh_aged_new.vue": [
		86339,
		6339
	],
	"./views/k3/k3_goods.vue": [
		54348,
		4348
	],
	"./views/k3/k3_sale_order.vue": [
		33607,
		3607
	],
	"./views/kasn/kacard.vue": [
		38952,
		8952
	],
	"./views/kasn/kacarddevice.vue": [
		8726,
		8726
	],
	"./views/kasn/kacardother.vue": [
		6868,
		6868
	],
	"./views/kasn/kamessage.vue": [
		93679,
		3679
	],
	"./views/kasn/kamessagedevice.vue": [
		81715,
		1715
	],
	"./views/kasn/kamessageother.vue": [
		10773,
		773
	],
	"./views/kasn/kasn.vue": [
		1593,
		1593
	],
	"./views/kasn/kasnshitu.vue": [
		77144,
		8975,
		7144
	],
	"./views/kasn/kasnshituIpad.vue": [
		53967,
		8975,
		3967
	],
	"./views/kasn/kasnshituwlyly.vue": [
		73823,
		8975,
		3823
	],
	"./views/kasn/kasnshituzhanhui.vue": [
		46032,
		8975,
		6032
	],
	"./views/lifeRader/life.vue": [
		80188,
		188
	],
	"./views/login.vue": [
		88306
	],
	"./views/login2.vue": [
		29518,
		9518
	],
	"./views/medicine_box/MedicineBox.vue": [
		85071,
		5071
	],
	"./views/mingzhen/aged_up.vue": [
		43904,
		3904
	],
	"./views/mingzhen/haikou/aged_up.vue": [
		98032,
		8032
	],
	"./views/mingzhen/haikou/chuangdai.vue": [
		61369,
		1369
	],
	"./views/mingzhen/haikou/em_up.vue": [
		27810,
		7810
	],
	"./views/mingzhen/haikou/nbiot_event_up.vue": [
		13486,
		3486
	],
	"./views/mingzhen/haikou/wg.vue": [
		345,
		345
	],
	"./views/mingzhen/haikou/workorder_up.vue": [
		80802,
		802
	],
	"./views/mingzhen/jianguan/aged_record.vue": [
		50341,
		341
	],
	"./views/mingzhen/jianguan/huanjinjiancha.vue": [
		80549,
		549
	],
	"./views/mingzhen/jianguan/report_aged_service_count.vue": [
		53877,
		3877
	],
	"./views/mingzhen/jianguan/report_aged_service_time.vue": [
		74871,
		4871
	],
	"./views/mingzhen/jianguan/slh_aged.vue": [
		29100,
		9100
	],
	"./views/mingzhen/jianguan/slh_qindan_xining.vue": [
		26394,
		6394
	],
	"./views/mingzhen/jianguan/taihe_gzgc.vue": [
		22027,
		2027
	],
	"./views/mingzhen/jianguan/tanshi_zhoufang.vue": [
		85702,
		5702
	],
	"./views/mingzhen/jianguan/workorder_manager.vue": [
		26965,
		6965
	],
	"./views/mingzhen/jianguan/workorder_manager_old.vue": [
		89882,
		9882
	],
	"./views/mingzhen/jianguan/yewu_zonglan.vue": [
		55940,
		5940
	],
	"./views/mingzhen/jianguan/zijin_bofu.vue": [
		87283,
		7283
	],
	"./views/mingzhen/jianguan/zijinbofu_zonglan.vue": [
		30068,
		68
	],
	"./views/mingzhen/jianguan/ziliao_shenhe.vue": [
		40290,
		290
	],
	"./views/mingzhen/luo_long_workorder_up.vue": [
		80259,
		259
	],
	"./views/mingzhen/luo_yang_alarm_push.vue": [
		2265,
		2265
	],
	"./views/mingzhen/wg.vue": [
		63634,
		3634
	],
	"./views/mingzhen/workorder_up.vue": [
		58711,
		8711
	],
	"./views/mingzhen/xi_ning_workorder_up.vue": [
		18698,
		8698
	],
	"./views/mingzhen/yang_quan_up.vue": [
		86040,
		6040
	],
	"./views/mingzhen/zsb.vue": [
		28038,
		8038
	],
	"./views/monitor/camera_h5.vue": [
		43474,
		5800,
		3474
	],
	"./views/monitor/camera_manager.vue": [
		14896,
		5800,
		4896
	],
	"./views/monitor/camera_manager_jiqiren.vue": [
		32325,
		5800,
		2325
	],
	"./views/monitor/camera_web.vue": [
		3720,
		5800,
		3720
	],
	"./views/monitor/chuangdai.vue": [
		24496,
		4496
	],
	"./views/monitor/monitor_map.vue": [
		88147,
		8147
	],
	"./views/monitor/monitor_map1.vue": [
		34060,
		4060
	],
	"./views/monitor/robot_patrol_record_z.vue": [
		31419,
		1419
	],
	"./views/monitor/robot_web.vue": [
		7130,
		5800,
		7130
	],
	"./views/nbiot/device_aqg.vue": [
		72599,
		2599
	],
	"./views/nbiot/journal_record.vue": [
		5108,
		5108
	],
	"./views/nbiot/nbiot.vue": [
		65300,
		5300
	],
	"./views/nbiot/nbiotHaiMan.vue": [
		85545,
		5545
	],
	"./views/nbiot/nbiot_event.vue": [
		73021,
		3021
	],
	"./views/nursingSupervision/nurse_grouping.vue": [
		59143,
		9143
	],
	"./views/nursingSupervision/nurse_monthly_schedule.vue": [
		43167,
		3167
	],
	"./views/pingantong/pingantong.vue": [
		80895,
		895
	],
	"./views/pinggu/huanjing.vue": [
		79064,
		9064
	],
	"./views/qinglanradar/multifunctionRadarStart.vue": [
		54741,
		4741
	],
	"./views/qinglanradar/qinglanradar.vue": [
		77215,
		7215
	],
	"./views/report/aged/slh_aged_pg_wx.vue": [
		33243,
		3243
	],
	"./views/report/aged/slh_aged_wx.vue": [
		83935,
		3935
	],
	"./views/report/aged/tfga.vue": [
		38164,
		8164
	],
	"./views/report/aged/wechat_IdCard.vue": [
		28065,
		8065
	],
	"./views/report/aged/wechat_TumbleRadar.vue": [
		63300,
		3300
	],
	"./views/report/aged/wechat_XingMai.vue": [
		45623,
		5623
	],
	"./views/report/aged/wechat_XueTangYi.vue": [
		11253,
		1253
	],
	"./views/report/aged/wechat_XueYaYi.vue": [
		90213,
		213
	],
	"./views/report/aged/wechat_YunXinSOS.vue": [
		38508,
		8508
	],
	"./views/report/aged/wechat_accessControl.vue": [
		37672,
		7672
	],
	"./views/report/aged/wechat_agedDelivery.vue": [
		10000,
		0
	],
	"./views/report/aged/wechat_agedResidence.vue": [
		54300,
		4300
	],
	"./views/report/aged/wechat_fourSoS_Phone.vue": [
		31463,
		1463
	],
	"./views/report/aged/wechat_healthAbility_img.vue": [
		95481,
		5481
	],
	"./views/report/aged/wechat_shouhuan.vue": [
		88818,
		8818
	],
	"./views/report/aged/wechat_whiteList.vue": [
		24789,
		4789
	],
	"./views/report/aged/weichat_SleepRadar.vue": [
		37909,
		7909
	],
	"./views/report/bigDate/aged_date.vue": [
		5937,
		5937
	],
	"./views/report/bigDate/aged_map.vue": [
		61420,
		1420
	],
	"./views/report/bigDate/anfang_map.vue": [
		18871,
		8871
	],
	"./views/report/bigDate/bed_map.vue": [
		61513,
		1513
	],
	"./views/report/bigDate/bed_transform.vue": [
		28126,
		8126
	],
	"./views/report/bigDate/chuangdian_map.vue": [
		3499,
		3499
	],
	"./views/report/bigDate/door_service.vue": [
		90622,
		622
	],
	"./views/report/bigDate/fuwu_map.vue": [
		44922,
		4922
	],
	"./views/report/bigDate/health_record.vue": [
		86008,
		6008
	],
	"./views/report/bigDate/leidabo_map.vue": [
		97419,
		2704,
		7419
	],
	"./views/report/bigDate/newShouhuan.vue": [
		82863,
		7751,
		1589,
		2863
	],
	"./views/report/bigDate/shengming_Radar.vue": [
		70243,
		243
	],
	"./views/report/bigDate/shouhuan_map.vue": [
		34849,
		7751,
		4849
	],
	"./views/report/bigDate/yunxinxiongka.vue": [
		16785,
		1589,
		6785
	],
	"./views/report/pg/ability_assessment2022.vue": [
		58141,
		8141
	],
	"./views/report/pg/assessment2022.vue": [
		18962,
		8962
	],
	"./views/report/pg/assessment2022new.vue": [
		10136,
		136
	],
	"./views/report/pg/assessment2025.vue": [
		63997,
		3997
	],
	"./views/report/pg/member_upd.vue": [
		72819,
		2819
	],
	"./views/report/pg/stay_assessment.vue": [
		12774,
		2774
	],
	"./views/report/report_aged_service_all.vue": [
		64799,
		7180
	],
	"./views/report/report_aged_service_count.vue": [
		8221,
		8221
	],
	"./views/report/report_aged_service_day.vue": [
		5468,
		5468
	],
	"./views/report/report_aged_service_money.vue": [
		79133,
		9133
	],
	"./views/report/report_aged_service_month.vue": [
		44235,
		4235
	],
	"./views/report/report_aged_service_project.vue": [
		93404,
		3404
	],
	"./views/report/report_aged_service_time.vue": [
		88238,
		8238
	],
	"./views/report/report_big_screen_1.vue": [
		4387,
		7390,
		4387
	],
	"./views/report/report_big_screen_10.vue": [
		29093,
		8612,
		9093
	],
	"./views/report/report_big_screen_100.vue": [
		52058,
		2058
	],
	"./views/report/report_big_screen_105.vue": [
		8434,
		8434
	],
	"./views/report/report_big_screen_14.vue": [
		71756,
		1756
	],
	"./views/report/report_big_screen_15.vue": [
		67693,
		8612,
		7693
	],
	"./views/report/report_big_screen_2.vue": [
		14415,
		4415
	],
	"./views/report/report_big_screen_20.vue": [
		83737,
		3737
	],
	"./views/report/report_big_screen_200.vue": [
		44563,
		7390,
		4563
	],
	"./views/report/report_big_screen_201.vue": [
		11844,
		7390,
		1844
	],
	"./views/report/report_big_screen_202.vue": [
		33567,
		7390,
		3567
	],
	"./views/report/report_big_screen_21.vue": [
		24190,
		4190
	],
	"./views/report/report_big_screen_22.vue": [
		3807,
		3807
	],
	"./views/report/report_big_screen_23.vue": [
		38462,
		8462
	],
	"./views/report/report_big_screen_24.vue": [
		83598,
		3598
	],
	"./views/report/report_big_screen_25.vue": [
		52479,
		2479
	],
	"./views/report/report_big_screen_26.vue": [
		39290,
		9290
	],
	"./views/report/report_big_screen_27.vue": [
		81968,
		1968
	],
	"./views/report/report_big_screen_28.vue": [
		7207,
		7207
	],
	"./views/report/report_big_screen_29.vue": [
		15748,
		5748
	],
	"./views/report/report_big_screen_3.vue": [
		75452,
		7390,
		5452
	],
	"./views/report/report_big_screen_30.vue": [
		99602,
		9602
	],
	"./views/report/report_big_screen_4.vue": [
		86416,
		7390,
		6416
	],
	"./views/report/report_big_screen_50.vue": [
		84073,
		4073
	],
	"./views/report/report_big_screen_51.vue": [
		38776,
		8776
	],
	"./views/report/report_big_screen_52.vue": [
		25808,
		5808
	],
	"./views/report/report_big_screen_53.vue": [
		9384,
		9384
	],
	"./views/report/report_big_screen_54.vue": [
		4058,
		4058
	],
	"./views/report/report_big_screen_55.vue": [
		84618,
		4618
	],
	"./views/report/report_big_screen_56.vue": [
		38747,
		8747
	],
	"./views/report/report_big_screen_57.vue": [
		87348,
		7348
	],
	"./views/report/report_big_screen_58.vue": [
		15813,
		5813
	],
	"./views/report/report_big_screen_6.vue": [
		22677,
		2677
	],
	"./views/report/report_big_screen_60.vue": [
		96491,
		6491
	],
	"./views/report/report_big_screen_61.vue": [
		75266,
		5266
	],
	"./views/report/report_big_screen_80.vue": [
		29783,
		7390,
		9783
	],
	"./views/report/report_big_screen_81.vue": [
		18419,
		7390,
		8419
	],
	"./views/report/report_big_screen_82.vue": [
		40358,
		7390,
		358
	],
	"./views/report/report_service_em_all.vue": [
		31096,
		1096
	],
	"./views/report/report_service_em_count.vue": [
		47040,
		7040
	],
	"./views/report/report_service_em_workhour.vue": [
		50554,
		554
	],
	"./views/report/wx_report/report_1.vue": [
		88270,
		8270
	],
	"./views/report/wx_report/report_2.vue": [
		21921,
		1921
	],
	"./views/report/wx_report/report_3.vue": [
		95123,
		5123
	],
	"./views/report/wx_report/report_4.vue": [
		86004,
		6004
	],
	"./views/report/xiangqing/aged_info.vue": [
		86074,
		6074
	],
	"./views/report/xiangqing/aged_shen_qing.vue": [
		70386,
		386
	],
	"./views/report/xiangqing/big_aged.vue": [
		50646,
		646
	],
	"./views/report/xiangqing/big_gai_zhao.vue": [
		56634,
		6634
	],
	"./views/report/xiangqing/big_gai_zhao_ty.vue": [
		96521,
		6521
	],
	"./views/report/xiangqing/big_shang_men_fu_wu.vue": [
		28603,
		8603
	],
	"./views/report/xiangqing/di_bao.vue": [
		36746,
		6746
	],
	"./views/report/xiangqing/gao_ning.vue": [
		99542,
		9542
	],
	"./views/report/xiangqing/ji_gou_lie_biao.vue": [
		83277,
		3277
	],
	"./views/report/xiangqing/ji_gou_xiang_qing.vue": [
		27541,
		7541
	],
	"./views/report/yongai/big_screen_1.vue": [
		46982,
		7390,
		6982
	],
	"./views/report/yongai/ji_gou_lie_biao.vue": [
		19777,
		9777
	],
	"./views/report/yongai/ji_gou_xiang_qing.vue": [
		67637,
		7637
	],
	"./views/robot/robot.vue": [
		32878,
		2878
	],
	"./views/robot/robot_patrol_record.vue": [
		24726,
		4726
	],
	"./views/scheduling/calendar.vue": [
		19672,
		9672
	],
	"./views/scheduling/grouping.vue": [
		96840,
		6840
	],
	"./views/scheduling/shift.vue": [
		49359,
		9359
	],
	"./views/screen/PersonSetting.vue": [
		16370,
		6370
	],
	"./views/screen/ProjectSetting.vue": [
		76154,
		6154
	],
	"./views/screen/ScreenShow.vue": [
		49953,
		9953
	],
	"./views/screen/index.vue": [
		58788,
		8788
	],
	"./views/smartScreen/smart_screen.vue": [
		18736,
		8736
	],
	"./views/stock/stock_product.vue": [
		77308,
		7308
	],
	"./views/stock/store_management.vue": [
		75279,
		5279
	],
	"./views/stock/warehousing.vue": [
		71543,
		1543
	],
	"./views/stock/warehousingChu.vue": [
		3207,
		3207
	],
	"./views/subsidy/subsidy_aged.vue": [
		62979,
		2979
	],
	"./views/subsidy/subsidy_di.vue": [
		62832,
		2832
	],
	"./views/subsidy/subsidy_gao.vue": [
		14338,
		4338
	],
	"./views/supplement/supplementAged.vue": [
		40644,
		644
	],
	"./views/supplement/supplementFood.vue": [
		14771,
		4771
	],
	"./views/supplement/supplementGoods.vue": [
		64793,
		4793
	],
	"./views/supplement/supplementLv.vue": [
		56936,
		6936
	],
	"./views/supplement/supplementST.vue": [
		66315,
		6315
	],
	"./views/supplyChain/contract.vue": [
		15851,
		5851
	],
	"./views/supplyChain/product.vue": [
		86631,
		6631
	],
	"./views/supplyChain/productCk.vue": [
		2818,
		2818
	],
	"./views/supplyChain/productNEW.vue": [
		61806,
		1806
	],
	"./views/supplyChain/purchaseProduct.vue": [
		74077,
		4077
	],
	"./views/supplyChain/purchaseRequisition.vue": [
		20408,
		408
	],
	"./views/supplyChain/yachangjin.vue": [
		13832,
		3832
	],
	"./views/supplyChain/yachangjinExcel.vue": [
		87048,
		7048
	],
	"./views/supplyChain/yaproductchuli.vue": [
		89688,
		9688
	],
	"./views/supplyChain/yaproductchuliOther.vue": [
		92172,
		2172
	],
	"./views/system/personal_project.vue": [
		52053,
		2053
	],
	"./views/system/project.vue": [
		75716,
		9135,
		5716
	],
	"./views/system/project_file.vue": [
		72411,
		2411
	],
	"./views/system/reform_project.vue": [
		97309,
		7309
	],
	"./views/system/role_manager.vue": [
		10043,
		43
	],
	"./views/system/role_permission.vue": [
		47064,
		7064
	],
	"./views/system/user_manager.vue": [
		95384,
		5384
	],
	"./views/system/user_register.vue": [
		88043,
		8043
	],
	"./views/visiting/visiting_care.vue": [
		87112,
		7112
	],
	"./views/visiting/visiting_problem.vue": [
		65413,
		5413
	],
	"./views/visiting/visiting_record.vue": [
		63466,
		3466
	],
	"./views/vr/index.vue": [
		31012,
		5729,
		9169,
		1012
	],
	"./views/vr/simpleDemo.vue": [
		26029,
		5729,
		6029
	],
	"./views/vr/vrExhibition/config.vue": [
		12790,
		5729,
		9169,
		3308,
		1085
	],
	"./views/vr/vrExhibition/index.vue": [
		59958,
		5729,
		9958
	],
	"./views/vr/vrExhibition/preview.vue": [
		76485,
		5729,
		9169,
		3308,
		7224
	],
	"./views/vr/vrExhibition/way.vue": [
		64365,
		5729,
		9169,
		3308,
		8272
	],
	"./views/vr/vrMarker/index.vue": [
		29314,
		9314
	],
	"./views/vr/vrScene/index.vue": [
		19411,
		5729,
		9411
	],
	"./views/vr/vrScene/preview.vue": [
		81845,
		5729,
		1845
	],
	"./views/wechat/login.vue": [
		59409,
		9409
	],
	"./views/wechat/tfga/tfga.vue": [
		81335,
		1335
	],
	"./views/xingmai/xingmai.vue": [
		47243,
		7243
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 85684;
module.exports = webpackAsyncContext;